import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=4998bea6&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/reenarafiq/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4998bea6"]])

export default __exports__